import useTranslator from "../../../hooks/useTranslator";
import { useNavigate } from "react-router-dom";

const BankingReadMore = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const handleGoHome = () => navigate("/tenant");

  return (
    <>
      <div className="flex-wrapper bank-page">
        <div className="greenbox-terms">
          <img className="orange-line" src="/images/orange-line.png" alt="" />
          <img className="white-line" src="/images/white-line.png" alt="" />
          <div className="logobar">
            <div className="go-back-home">
              <a href={undefined} onClick={handleGoHome}>
                <svg
                  width="54"
                  height="54"
                  viewBox="0 0 54 54"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="27"
                    cy="27"
                    r="26.5"
                    fill="#253837"
                    stroke="#A3EB64"
                  />
                  <path
                    d="M24.9821 22.1376L24.9884 22.1314L24.995 22.1256C25.0335 22.0911 25.0632 22.0505 25.0834 22.007C25.1035 21.9635 25.114 21.9173 25.1149 21.8711C25.1157 21.8249 25.1069 21.7785 25.0885 21.7346C25.07 21.6906 25.0419 21.6493 25.0049 21.6137C24.9679 21.578 24.9226 21.5489 24.8714 21.529C24.8202 21.5091 24.7647 21.4991 24.7085 21.5001C24.6522 21.501 24.5972 21.5129 24.5469 21.5344C24.4967 21.556 24.4527 21.5865 24.4172 21.6232L24.4111 21.6295L24.4047 21.6356L19.6098 26.2488C19.6098 26.2489 19.6097 26.2489 19.6097 26.2489C19.5371 26.319 19.5 26.4097 19.5 26.5C19.5 26.5903 19.5371 26.681 19.6097 26.7511C19.6097 26.7511 19.6098 26.7511 19.6098 26.7512L24.4047 31.3644L24.4111 31.3705L24.4172 31.3768C24.4527 31.4135 24.4967 31.444 24.5469 31.4656C24.5972 31.4871 24.6522 31.499 24.7085 31.4999C24.7647 31.5009 24.8202 31.4909 24.8714 31.471C24.9226 31.4511 24.9679 31.422 25.0049 31.3863C25.0419 31.3507 25.07 31.3094 25.0885 31.2654C25.1069 31.2215 25.1157 31.1751 25.1149 31.1289C25.114 31.0827 25.1035 31.0365 25.0834 30.993C25.0632 30.9495 25.0335 30.909 24.995 30.8744L24.9884 30.8686L24.9821 30.8624L21.7214 27.7253L20.8272 26.865L22.0681 26.865L33.6842 26.865C33.7962 26.865 33.8998 26.822 33.9733 26.7513C34.0462 26.6813 34.0833 26.5904 34.0833 26.5C34.0833 26.4096 34.0462 26.3187 33.9733 26.2487C33.8998 26.178 33.7962 26.135 33.6842 26.135L22.0681 26.135L20.8272 26.135L21.7214 25.2747L24.9821 22.1376Z"
                    fill="#FFB65A"
                    stroke="white"
                  />
                </svg>
                <span className="color-green">{_t("goBack")} </span>
              </a>
            </div>
          </div>
          <div class="container">
            <div class="terms-heading">
              <img src="/images/tink-Logo.png" alt="" />
              <h3 class="what-we-heading">
                {_t("yourSecurityAndPrivacyAreOurTopPriority")}
              </h3>
            </div>
          </div>
          <img
            className="skore-white-logo"
            src="/images/Skor-white-logo(2).png"
            alt=""
          />
        </div>
        <section class="bank-body">
          <div class="">
            <p>
              {_t(
                "asYouProceedToConnectYourBankAccountThroughOurPartnerTinkWeWantToAssureYouOfTheUtmostPrivacyAndSecurityOfYourFinancialDataHereIsHowWeProtectYou"
              )}
            </p>
            <h3>{_t("bankLevelSecurity")}</h3>
            <p>
              {_t(
                "tinksPlatformOperatesWithBankLevelSecurityMeasuresEnsuringThatYourFinancialInformationIsEncryptedAndSecurelyTransmittedWithoutCompromise"
              )}
            </p>
            <h3>{_t("privacyByDesign")}</h3>
            <p>
              {_t(
                "yourPrivacyIsParamountWeAdhereToStrictDataProtectionRegulationsAndEmployAPrivacyByDesignApproachToSafeguardYourInformationAtEveryStep"
              )}
            </p>
            <h3>{_t("noDirectAccessToYourBankDetails")}</h3>
            <p>
              {_t(
                "itsImportantForYouToKnowThatWeDoNotHaveDirectAccessToYourBankLoginDetailsThisProcessIsDesignedToMaintainYourCredentialsEncriptedFromSkorOrAnyOtherThirdParty"
              )}
            </p>
            <h3>{_t("controlInYourHands")}</h3>
            <p>
              {_t(
                "youHaveFullControlOverYourDataYouCanManageYourPermissionsAndDecideWhatInformationIsSharedEnsuringYouHavePowerOverYourData"
              )}
            </p>
            <h3>{_t("transparentPractices")}</h3>
            <p>
              {_t(
                "weBelieveInTransparencyOurPartnershipWithTinkIsFocusedOnProvidingYouWithSeamlessServicesWithoutCompromisingYourPrivacyOrSecurity"
              )}
            </p>
            <p>
              {_t(
                "yourTrustIsInvaluableToUsAndWeAreCommittedToMaintainingTheHighestStandardsOfDataProtectionAndPrivacyShouldYouHaveAnyConcernsOrQuestionsOurSupportTeamIsHereToAssistYouEveryStepOfTheWay"
              )}
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default BankingReadMore;
